import React from 'react';
import {WeaSearchGroup,WeaFormItem,WeaCheckbox} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';

// 费用报销智能助手
export default class Content_fnaBudgetAssistant extends React.Component {
    state = {
        ePersonalBorrowinInformation: this.props.ePersonalBorrowinInformation,
        eReimbursementInformation: this.props.eReimbursementInformation,
        eReimbursementChart: this.props.eReimbursementChart
    };
    render() {
    const { eReimbursementInformation, ePersonalBorrowinInformation, eReimbursementChart} = this.state;
    
    let EPersonalBorrowinInformation = (
            <WeaFormItem label={getLabel(126747, '个人借款信息')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <WeaCheckbox value={ePersonalBorrowinInformation} onChange={(value)=>this.setState({ePersonalBorrowinInformation: value})}/>
            </WeaFormItem>
        );
    
    let EReimbursementInformation = (
            <WeaFormItem label={getLabel(126748, '报销信息')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <WeaCheckbox value={eReimbursementInformation} onChange={(value)=>this.setState({eReimbursementInformation: value})}/>
            </WeaFormItem>
        );
    
    let EReimbursementChart = (
            <WeaFormItem label={getLabel(126750, '报销图表')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                <WeaCheckbox value={eReimbursementChart} onChange={(value)=>this.setState({eReimbursementChart: value})}/>
            </WeaFormItem>
        );
        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    {EPersonalBorrowinInformation}
                    {EReimbursementInformation}
                    {EReimbursementChart}
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentPersonalBorrowinInformation: this.state.ePersonalBorrowinInformation,
            eContentReimbursementInformation: this.state.eReimbursementInformation,
            eContentReimbursementChart: this.state.eReimbursementChart
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_fnaBudgetAssistant.js